<template>
    <v-toolbar class="pink darken-2" dark>
        <v-toolbar-title>Tableau des Activités Principales des Sénateurs</v-toolbar-title>

        <v-spacer></v-spacer>
    </v-toolbar>
</template>
<script>
export default {

};
</script>
<style>

</style>


// WEBPACK FOOTER //
// AccueilToolbar.vue?9edbb874